import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import './AdminDashboard.css'; // Reuse the same CSS file
import axiosInstance from './axiosInstance'; // Import the axios instance

const AdminTutors = ({ showNames }) => {
    const [adminFirstName, setAdminFirstName] = useState('Admin');

    const [tutors, setTutors] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const tutorsPerPage = 10;

    useEffect(() => {
        const fetchTutors = async () => {
            const token = Cookies.get('token');
            if (!token) {
                // Handle the case where the token is not available
                console.error('No token found');
                return;
            }

            try {
                const response = await axiosInstance.get('/admin/tutors', {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (response.data) {
                    setTutors(response.data); // The response is an array of tutor objects
                } else {
                    console.error('Invalid response format:', response.data);
                }
            } catch (error) {
                console.error('Error fetching tutors:', error);
            }
        };

        fetchTutors();
    }, []);

    useEffect(() => {
        const fetchAdminFirstName = async () => {
            try {
                const response = await axiosInstance.get('/admin/first-name');
                setAdminFirstName(response.data.first_name);
            } catch (err) {
                console.error('Failed to fetch admin first name', err);
            }
        };

        fetchAdminFirstName();
    }, []);

    // Calculate the current tutors to display
    const indexOfLastTutor = currentPage * tutorsPerPage;
    const indexOfFirstTutor = indexOfLastTutor - tutorsPerPage;
    const currentTutors = tutors.slice(indexOfFirstTutor, indexOfLastTutor);

    // Handle pagination
    const nextPage = () => {
        if (currentPage < Math.ceil(tutors.length / tutorsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <div className={`admin-dashboard-container ${showNames ? 'show-names' : ''}`}>
            <div className="mini-header">
                <h1 className="mini-header-title">Admin Tutors</h1>
                <div className="mini-header-right">
                    <span className="admin-name">{adminFirstName}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                        <path fill="currentColor" d="M23 9A7 7 0 1 1 9 9a7 7 0 0 1 14 0m-2 0a5 5 0 1 0-10 0a5 5 0 0 0 10 0M7.5 18A3.5 3.5 0 0 0 4 21.5v.5c0 2.393 1.523 4.417 3.685 5.793C9.859 29.177 12.802 30 16 30s6.14-.823 8.315-2.207C26.477 26.417 28 24.393 28 22v-.5a3.5 3.5 0 0 0-3.5-3.5zM6 21.5A1.5 1.5 0 0 1 7.5 20h17a1.5 1.5 0 0 1 1.5 1.5v.5c0 1.473-.94 2.949-2.759 4.106C21.434 27.256 18.877 28 16 28s-5.434-.744-7.241-1.894C6.939 24.95 6 23.472 6 22z" />
                    </svg>
                </div>
            </div>
            <div className="dashboard-container">
                <div className="dashboard-content">
                    <div className="admin-users-table-container">
                        <table className="admin-users-table">
                            <thead>
                                <tr>
                                    <th>S/N</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Email Address</th>
                                    <th>Phone Number</th>
                                    <th>Level</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentTutors.map((tutor, index) => (
                                    <tr key={tutor.id}>
                                        <td>{indexOfFirstTutor + index + 1}</td>
                                        <td>{tutor.first_name}</td>
                                        <td>{tutor.last_name}</td>
                                        <td>{tutor.email}</td>
                                        <td>{tutor.phone_number}</td>
                                        <td>{tutor.level}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="pagination">
                        <button onClick={prevPage} disabled={currentPage === 1}>Previous</button>
                        <button onClick={nextPage} disabled={currentPage === Math.ceil(tutors.length / tutorsPerPage)}>Next</button>
                    </div>
                    <div className="pagination-info">
                        <p>Showing {indexOfFirstTutor + 1} to {Math.min(indexOfLastTutor, tutors.length)} of {tutors.length} tutors</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminTutors;